export default __webpack_public_path__ + "static/footer-gradient-2e19402ba43c614f5863e9a2b7b2fd8a.png";